// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__UlBKp","floating":"style_floating__rV21y","not-visible":"style_not-visible__Ez2cP","button":"style_button__zNxad","popover":"style_popover__tA126"};